export const REVIEWS_LIST_WIDTH = 750;
export const MINIMUM_REVIEWS_NEEDED_TO_DISPLAY = 10;